import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { timer } from 'rxjs';
import { AgentService } from '../../core/agent/agent.service';
import { UserService } from '../../core/user/user.service';

@Component({
    selector: 'rosie-number',
    templateUrl: './rosie-number.component.html',
    styleUrls: ['./rosie-number.component.scss'],
    standalone: false
})
export class RosieNumberComponent implements OnInit {
    copiedValue = null;

    @Output() requestLocalAreaCodeClicked = new EventEmitter<string>();

    constructor(private agent: AgentService, private user: UserService) {
    }

    get agentPhoneNumber(): string {
        return this.agent.phoneNumber;
    }

    get isUserOnFreeMinutesBillingVersion(): boolean {
        return this.user.isUserOnFreeMinutesBillingVersion;
    }

    ngOnInit(): void {
    }

    get hasCopiedValue(): boolean {
        return this.agentPhoneNumber && this.copiedValue === this.agentPhoneNumber;
    }

    copyFieldValue() {
        this.copiedValue = this.agentPhoneNumber;
        navigator.clipboard.writeText(this.agentPhoneNumber).then();
        timer(2500).subscribe(() => this.copiedValue = null);
    }

    onRequestLocalAreaCodeClicked() {
        this.requestLocalAreaCodeClicked.emit('use-rosie-number');
    }
}
